import { login } from '@/Store/login'
import './api/fbConnect'
import fbLogin from './store/fbLogin'

login.actions = {...login.actions, ...fbLogin.actions}